import { NumberInput as MantineNumberInput, type NumberInputProps as MantineNumberInputProps } from '@mantine/core'

export type NumberInputProps = MantineNumberInputProps

export function NumberInput(props: Readonly<NumberInputProps>) {
  return <MantineNumberInput {...props} />
}
